import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaBars, FaTimes, FaSearch, FaHandshake, FaExternalLinkAlt } from "react-icons/fa";
import logo from "../assets/images/logo_quarkia.png";
import banner1 from "../assets/images/banner1.jpg";
import banner2 from "../assets/images/banner2.jpg";
import banner3 from "../assets/images/banner3.jpg";
import boton1 from "../assets/images/boton1.jpg";
import boton2 from "../assets/images/boton2.jpg";
import boton3 from "../assets/images/boton3.jpg";

// 🤝 Logos de aliados (subir estos archivos a src/assets/images/)
import fractalLogo from "../assets/images/logofractal.svg";
import cacLogo from "../assets/images/cac_logo.png";
import sinergiaLogo from "../assets/images/sinergia_logo.png";

import Navbar from "./Navbar";

import { FaWhatsapp, FaInstagram, FaLinkedin, FaFacebook, FaEnvelope, FaPhoneAlt } from "react-icons/fa";



const banners = [banner1, banner2, banner3];

// ======= ALIADOS DE QUARKIA =======
const aliados = [
  {
    nombre: "Fractal BIC",
    descripcion:
      "Empresa de consultores especializada en soluciones estratégicas y acompañamiento experto a organizaciones del sector energético.",
    logo: fractalLogo,
    url: "https://fractalbic.com/",
    color: "from-[#00b3b3] to-[#00e68a]",
  },
  {
    nombre: "CAC",
    descripcion:
      "Comité Asesor de Comercialización del Sector Eléctrico con amplia trayectoria en el sector eléctrico colombiano, aportando conocimiento técnico y experiencia comercial.",
    logo: cacLogo,
    url: "https://cac.org.co/",
    color: "from-purple-500 to-pink-500",
  },
  {
    nombre: "SinergIA",
    descripcion:
      "Aliado en innovación y desarrollo de soluciones inteligentes que potencian la transformación digital del sector. ",
    logo: sinergiaLogo,
    url: "https://sinergiaads.com/",
    color: "from-yellow-400 to-orange-500",
  },
];

export default function HomeForm() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [textAnimating, setTextAnimating] = useState(false);

  // 🔁 Cambia de banner cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setTextAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % banners.length);
        setTextAnimating(false);
      }, 300); // animación antes del cambio
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className="w-full bg-[#231f2b] text-white font-[Nexa]">

      <Navbar />
      {/* Resto del contenido de HomeForm */}


      {/* ======= BANNER PRINCIPAL ======= */}
      <section
        className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden cursor-pointer"
        onClick={() => {
          if (currentIndex === 0) window.location.href = "/sobrenosotros";
          else if (currentIndex === 1) window.location.href = "/servicios";
          else if (currentIndex === 2) window.location.href = "/register";
        }}
      >
        {/* Imagen de fondo */}
        {banners.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentIndex ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={img}
              alt={`Banner ${index + 1}`}
              className="w-full h-full object-cover object-center"
            />
          </div>
        ))}

        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

        {/* 🔹 Texto dinámico según el banner */}
        <div
          className={`absolute top-10 left-10 md:top-16 md:left-16 text-left z-10 transition-all duration-700 ${
            textAnimating ? "animate-slideIn" : "animate-fadeIn"
          }`}
        >
          {currentIndex === 0 && (
            <h1 className="text-3xl md:text-5xl font-elianto uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.7)]">
              InteligenciA
              <br />
              en MovimientO
            </h1>
          )}

          {currentIndex === 1 && (
            <h1 className="text-3xl md:text-5xl font-elianto uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.7)]">
              Decisiones
              <br />
              basadas en Datos
            </h1>
          )}

          {currentIndex === 2 && (
            <h1 className="text-3xl md:text-5xl font-elianto uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.7)]">
              Energía Inteligente
              <br />
              y Sostenible
            </h1>
          )}
        </div>

        {/* 🔹 Texto inferior derecho fijo */}
        <div
          className={`absolute bottom-10 right-10 md:bottom-16 md:right-16 text-right z-10 max-w-sm md:max-w-md ${
            textAnimating ? "animate-slideIn" : "animate-fadeIn"
          }`}
        >
          <p className="font-nexa font-normal text-white text-sm md:text-lg leading-snug">
            Una nueva forma de <br />
            gestionar inteligentemente las empresas
          </p>
        </div>

        {/* Indicadores (puntos) */}
        <div className="absolute bottom-5 w-full flex justify-center space-x-3 z-20">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentIndex(index);
              }}
              className={`w-3 h-3 rounded-full transition-all ${
                currentIndex === index
                  ? "bg-[#00b3b3] scale-110"
                  : "bg-gray-400 hover:bg-[#00b3b3]"
              }`}
            />
          ))}
        </div>
      </section>
          

      {/* ======= SECCIÓN DE BOTONES ======= */}
      <section className="bg-[#231f2b] py-12 px-6 flex flex-col items-center font-nexa font-normal">
        <div className="max-w-7xl w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          
          {/* CARD 1 */}
          <div
            className="flex flex-col items-center text-center cursor-pointer"
            onClick={() => (window.location.href = "/noticias")}
          >
            <div className="relative group overflow-hidden rounded-md">
              <img
                src={boton1}
                alt="Energía al día"
                className="w-full h-80 md:h-96 lg:h-[28rem] object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <button className="bg-[#0b625f] hover:bg-[#007e7e] text-white px-5 py-2 rounded-full font-semibold transition">
                  Ver más
                </button>
              </div>
            </div>
            <p className="mt-4 text-lg text-white">Energía al día</p>
            <p className="text-gray-300 text-sm">Actualidad del sector</p>
          </div>

          {/* CARD 2 */}
          <div
            className="flex flex-col items-center text-center cursor-pointer"
            onClick={() => (window.location.href = "/nuestroportafolio")}
          >
            <div className="relative group overflow-hidden rounded-md">
              <img
                src={boton2}
                alt="Portafolio de servicios"
                className="w-full h-80 md:h-96 lg:h-[28rem] object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <button className="bg-[#0b625f] hover:bg-[#007e7e] text-white px-5 py-2 rounded-full font-semibold transition">
                  Ver más
                </button>
              </div>
            </div>
            <p className="mt-4 text-lg text-white">Portafolio</p>
            <p className="text-gray-300 text-sm">de servicios</p>
          </div>


          {/* CARD 3 */}
          <div
            className="flex flex-col items-center text-center cursor-pointer"
            onClick={() => (window.location.href = "/informaciongratuita")}
          >
            <div className="relative group overflow-hidden rounded-md">
              <img
                src={boton3}
                alt="Información gratuita disponible"
                className="w-full h-80 md:h-96 lg:h-[28rem] object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <button className="bg-[#0b625f] hover:bg-[#007e7e] text-white px-5 py-2 rounded-full font-semibold transition">
                  Ver más
                </button>
              </div>
            </div>
            <p className="mt-4 text-lg text-white">Información gratuita</p>
            <p className="text-gray-300 text-sm">disponible para consulta</p>
          </div>

        </div>
      </section>


      {/* ======= SECCIÓN DE ALIADOS ======= */}
      <section className="bg-[#231f2b] py-16 px-6 font-nexa font-normal border-t border-white/5">
        <div className="max-w-7xl mx-auto">
          {/* Encabezado */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <FaHandshake />
              <span>Aliados estratégicos</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
              Nuestros{" "}
              <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
                aliados
              </span>
            </h2>
            <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto">
              QuarkIA trabaja de la mano con empresas líderes en el sector energético
              que fortalecen el ecosistema de transformación social, económica y digital, 
              viabilizando la Transición Energética y la evolución de los territorios y las empresas.
            </p>
          </div>

          {/* Tarjetas de aliados */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {aliados.map((aliado, i) => (
              <a
                key={i}
                href={aliado.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-[#2c2833] rounded-2xl p-8 border border-white/5 hover:border-[#00e68a]/40 hover:-translate-y-2 transition-all duration-300 overflow-hidden block"
              >
                {/* Efecto de fondo al hover */}
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${aliado.color} opacity-0 group-hover:opacity-5 transition-opacity`}
                ></div>

                {/* Ícono de enlace externo en esquina */}
                <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#231f2b]/60 flex items-center justify-center text-gray-400 group-hover:text-[#00e68a] group-hover:bg-[#00e68a]/10 transition-all">
                  <FaExternalLinkAlt className="text-xs" />
                </div>

                {/* Contenedor del logo */}
                <div className="relative w-full h-32 bg-white rounded-xl flex items-center justify-center mb-6 p-4 shadow-lg group-hover:shadow-[0_0_20px_rgba(0,230,138,0.2)] transition-all">
                  <img
                    src={aliado.logo}
                    alt={`Logo ${aliado.nombre}`}
                    className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform"
                  />
                </div>

                {/* Nombre */}
                <h3 className="relative text-2xl font-bold text-white text-center mb-3 group-hover:text-[#00e68a] transition-colors">
                  {aliado.nombre}
                </h3>

                {/* Descripción */}
                <p className="relative text-gray-300 text-sm text-center leading-relaxed">
                  {aliado.descripcion}
                </p>

                {/* Línea decorativa inferior */}
                <div
                  className={`relative mt-6 h-1 w-0 group-hover:w-full bg-gradient-to-r ${aliado.color} rounded-full transition-all duration-500 mx-auto`}
                ></div>

                {/* Texto "Visitar sitio" */}
                <p className="relative text-center text-xs text-gray-500 mt-4 group-hover:text-[#00e68a] transition-colors">
                  Visitar sitio web →
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>


      {/* ======= FOOTER ======= */}
      <footer className="w-full font-nexa font-normal">
        {/* Franja gris superior */}
        <div className="bg-gray-600 text-white flex flex-col md:flex-row justify-between items-center px-8 py-6 md:py-8 gap-6 md:gap-0">
            {/* Contacto */}
            <div className="text-center md:text-left space-y-2">
            <p className="flex items-center justify-center md:justify-start gap-2 text-[16px]">
                <FaEnvelope className="text-[#00b3b3]" />
                <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center justify-center md:justify-start gap-2 text-[15px]">
                <FaPhoneAlt className="text-[#00b3b3]" />
                <span>+57 311 383 68 55</span>
            </p>
            </div>

            {/* Redes sociales */}
            <div className="flex space-x-6 text-[#00b3b3] text-3xl">
            <a
                href="https://wa.me/573113836855"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
            >
                <FaWhatsapp />
            </a>
            <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
            >
                <FaInstagram />
            </a>
            <a
                href="https://www.linkedin.com/company/quarkia"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
            >
                <FaLinkedin />
            </a>
            <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
            >
                <FaFacebook />
            </a>
            </div>
        </div>

        {/* Franja inferior */}
        <div className="bg-[#231f2b] text-center text-gray-300 text-sm py-3">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
        </div>
      </footer>

    </main>
  );
}
